import React, { useCallback, useEffect, useState } from "react";
import {
  SelectAppDataProps,
  SelectVideoAppDataProps,
} from "../../../../Types/Workflow-Types";
import {
  getTruncatedFilename,
  MessageType,
  WorkflowAppInputAndOutputTypes,
} from "../../../../Helper";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Radio from "@mui/material/Radio";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  getVideoSuiteType,
  SettingItemObjType,
  VideoSettings,
} from "../../../../Types/VideoSuite-Types";
import { useAppDispatch } from "../../../../store/hooks";
import WorkflowUploadInputImage from "../Shared/WorkflowUploadInputImage";
import WorkflowInputText from "../Shared/WorkflowInputText";
import { useGenerateRandomPrompt } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import SignalRService from "../../../one-query/services/SignalRService";
import { useGetVideoSuiteAppSettings } from "../../../../store/Apis/SuitesApps/VideoSuiteApi";
import { setVideoAppSettings } from "../../../../store/one-query/workflowsSlice";
import SettingItem from "../Shared/SettingItem";
import OutputSettingVideo from "../Shared/OutputSettingVideo";
import InfoItem from "../Shared/InfoItem";
import WorkflowSettingTabs from "../Shared/WorkflowSettingTabs";
interface videoSettingsMenuOpen {
  model: boolean;
  dimension: boolean;
  style: boolean;
  duration: boolean;
  quality: boolean;
}
export interface ImageToVideoSettingProps
  extends SelectAppDataProps,
    SelectVideoAppDataProps {}
const ImageToVideoSetting = ({
  currentStep,
  videoSettings,
  handleModelSettingChanges,
  outputTypeOfLastApp,
  handleUserInputImageChange,
  handleUserInputTextChange,
  isFirstStep,
  readOnly,
  canShow,
}: ImageToVideoSettingProps) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [activeAppId, setActiveAppId] = useState<string>("");
  const { data: videoSuiteAppSettings } =
    useGetVideoSuiteAppSettings(activeAppId);
  const selectedModelData = videoSuiteAppSettings?.find(
    (item: VideoSettings) => item.name === videoSettings?.selectedModel.name
  );
  const dispatch = useAppDispatch();

  const [isFinished, setIsFinished] = useState(false);
  const [generatedPrompt, setGeneratedPrompt] = useState("");
  const [menuOpen, setMenuOpen] = useState<videoSettingsMenuOpen>({
    model: false,
    dimension: false,
    style: false,
    duration: false,
    quality: false,
  });
  const { mutate: GenerateRandomPrompt, isPending: IsGeneratePromptLoading } =
    useGenerateRandomPrompt();

  useEffect(() => {
    if (currentStep?.appId) setActiveAppId(currentStep?.appId);
  }, [currentStep?.appId]);

  useEffect(() => {
    if (videoSuiteAppSettings)
      dispatch(setVideoAppSettings(videoSuiteAppSettings));
  }, [videoSuiteAppSettings]);

  useEffect(() => {
    if (currentStep?.videoSettings?.selectedModel?.name) {
      const selectedModel = videoSuiteAppSettings?.find(
        (item: VideoSettings) =>
          item.name === currentStep?.videoSettings?.selectedModel?.name
      );
      if (selectedModel) {
        // Check if selectedSize exists in selectedModel.modelDimensions
        const sizeExists = selectedModel.modelDimensions?.some(
          (dim: SettingItemObjType) =>
            dim.description === currentStep?.videoSettings?.selectedSize
        );
        if (!sizeExists && selectedModel.modelDimensions?.length) {
          handleModelSettingChanges?.(
            currentStep?.appId || "",
            "selectedSize",
            selectedModel.modelDimensions[0].description
          );
        }

        // Check if selectedStyle exists in selectedModel.modelStyles
        const styleExists = selectedModel.modelStyles?.some(
          (style: SettingItemObjType) =>
            style.description ===
            currentStep?.videoSettings?.selectedStyle?.description
        );
        if (!styleExists && selectedModel.modelStyles?.length) {
          handleModelSettingChanges?.(
            currentStep?.appId || "",
            "selectedStyle",
            selectedModel.modelStyles[0]
          );
        }

        // Check if selectedMode exists in selectedModel.modelVideoQualities
        const modeExists = selectedModel.modelVideoQualities?.some(
          (mode: SettingItemObjType) =>
            mode.description === currentStep?.videoSettings?.selectedMode
        );
        if (!modeExists && selectedModel.modelVideoQualities?.length) {
          handleModelSettingChanges?.(
            currentStep?.appId || "",
            "selectedMode",
            selectedModel.modelVideoQualities[0].description
          );
        }

        // Check if selectedDuration exists in selectedModel.modelDurations
        const durationExists = selectedModel.modelDurations?.some(
          (duration: any) =>
            duration.value === currentStep?.videoSettings?.selectedDuration
        );
        if (!durationExists && selectedModel.modelDurations?.length) {
          handleModelSettingChanges?.(
            currentStep?.appId || "",
            "selectedDuration",
            selectedModel.modelDurations[0].value
          );
        }
      }
    }
  }, [currentStep?.videoSettings?.selectedModel?.name]);

  useEffect(() => {
    if (isFinished) {
      setIsFinished(false);
      setGeneratedPrompt("");
    }
  }, [isFinished]);
  const handleGenerateImageSuitesSignalR = useCallback(
    (
      modelName: string,
      modelVersion: string,
      message: string,
      tag: string,
      conversationId: string,
      messageId: string,
      messageType: number
    ) => {
      if (message === "**/**Finished**/**") {
        setIsFinished(true);
      } else {
        if (messageType === MessageType.Utility && message !== null) {
          setGeneratedPrompt((prev) => (prev ? prev + message : message));
        }
      }
    },
    []
  );

  const setupSignalRConnection = useCallback(() => {
    const connection = SignalRService.getInstance().connection;
    connection.on("SendModelMessage", handleGenerateImageSuitesSignalR);
    return () => {
      connection.off("SendModelMessage", handleGenerateImageSuitesSignalR);
    };
  }, [handleGenerateImageSuitesSignalR]);

  useEffect(() => {
    const cleanup = setupSignalRConnection();
    return () => {
      cleanup();
    };
  }, [setupSignalRConnection]);
  const handelGenerateRandomPrompt = async () => {
    setGeneratedPrompt("");
    const connectionId = await SignalRService.getInstance().getConnectionId();
    const RequestData = {
      connectionId: connectionId,
      type: getVideoSuiteType(true) + "",
    };
    GenerateRandomPrompt(RequestData);
  };

  const handleClearImage = () => {
    handleUserInputImageChange?.("", null);
  };
  const handleOpenMenu = (name: string) =>
    setMenuOpen((prev) => ({ ...prev, [name]: true }));
  const handleCloseMenu = (name: string) =>
    setMenuOpen((prev) => ({ ...prev, [name]: false }));

  return canShow ? (
    !readOnly ? (
      <Box className="w-100 d-flex flex-column justify-content-center ">
        <Box className="w-100 d-flex flex-column justify-content-center container-video-setting-workflow">
          <Box
            sx={{
              flexGrow: 1,
              justifyContent: "space-between",
              display: "flex",
              gap: "8px",
            }}
          >
            <WorkflowSettingTabs value={value} handleChange={handleChange} />
            <SettingItem value={value} index={0}>
              {outputTypeOfLastApp && outputTypeOfLastApp !== "" ? (
                outputTypeOfLastApp === WorkflowAppInputAndOutputTypes.Text ||
                currentStep?.userInput ? (
                  <Box
                    sx={{
                      width: "100%",
                    }}
                  >
                    <InfoItem
                      header="Text"
                      inputText={
                        !isFirstStep
                          ? "Text will be added from the previous step."
                          : "Text will be added at runtime."
                      }
                    />
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        gap: "8px",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "16px",
                          padding: "5px 11px",
                          gap: "8px",
                          background: "#12B6EA",
                          position: "absolute",
                          top: "2%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CheckIcon
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "var(--backgroud2)",
                          }}
                        />
                      </Box>
                      <Typography
                        className="ms-4 ps-2 me-3"
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "20px",
                          letterSpacing: "0.25px",
                          color: "#12B6EA",
                          opacity: "0.8",
                        }}
                      >
                        Image:
                      </Typography>
                    </Box>
                    <WorkflowUploadInputImage
                      imageValue={currentStep?.userInput as File}
                      handleInputImageChange={handleUserInputImageChange}
                      handleClearImage={handleClearImage}
                      activeAppId={currentStep?.appId || ""}
                      readOnly={readOnly}
                    />
                  </Box>
                ) : outputTypeOfLastApp ===
                    WorkflowAppInputAndOutputTypes.Image ||
                  currentStep?.userInputText ? (
                  <>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        gap: "8px",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "16px",
                          padding: "5px 11px",
                          gap: "8px",
                          background: "#12B6EA",
                          position: "absolute",
                          top: "2%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CheckIcon
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "var(--backgroud2)",
                          }}
                        />
                      </Box>
                      <Typography
                        className="ms-4 ps-2 me-3"
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "20px",
                          letterSpacing: "0.25px",
                          color: "#12B6EA",
                          opacity: "0.8",
                        }}
                      >
                        Text:
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                      }}
                    >
                      <WorkflowInputText
                        handelGenerateRandomPrompt={handelGenerateRandomPrompt}
                        IsGeneratePromptLoading={IsGeneratePromptLoading}
                        handleUserInputTextChange={handleUserInputTextChange}
                        activeAppId={currentStep?.appId || ""}
                        inputValue={currentStep?.userInputText as string}
                        generatedPrompt={generatedPrompt}
                        readOnly={readOnly}
                      />
                    </Box>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        gap: "8px",
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "16px",
                        flexWrap: "wrap",
                        marginTop:
                          outputTypeOfLastApp ===
                          WorkflowAppInputAndOutputTypes.Image
                            ? "16px"
                            : "0px",
                      }}
                    >
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "16px",
                          padding: "5px 11px",
                          gap: "8px",
                          background: "#12B6EA",
                          position: "absolute",
                          top: "2%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <CheckIcon
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "var(--backgroud2)",
                          }}
                        />
                      </Box>
                      <Typography
                        className="ms-4 ps-2 me-3"
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "20px",
                          letterSpacing: "0.25px",
                          color: "#12B6EA",
                          opacity: "0.8",
                        }}
                      >
                        Image:
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "25px",
                          letterSpacing: "0.1px",
                          textDecoration: "underline",
                          color: "var(--Main_icons_color)",
                        }}
                      >
                        {!isFirstStep
                          ? "Image will be added from the previous step."
                          : "Image will be added at runtime."}
                      </Typography>
                    </Box>
                  </>
                ) : null
              ) : (
                <>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      gap: "8px",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      sx={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "16px",
                        padding: "5px 11px",
                        gap: "8px",
                        background: "#12B6EA",
                        position: "absolute",
                        top: "2%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CheckIcon
                        sx={{
                          width: "18px",
                          height: "18px",
                          color: "var(--backgroud2)",
                        }}
                      />
                    </Box>
                    <Typography
                      className="ms-4 ps-2 me-3"
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "20px",
                        letterSpacing: "0.25px",
                        color: "#12B6EA",
                        opacity: "0.8",
                      }}
                    >
                      Text:
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "25px",
                        letterSpacing: "0.1px",
                        textDecoration: "underline",
                        color: "var(--Main_icons_color)",
                        marginLeft: "9px",
                      }}
                    >
                      {!isFirstStep
                        ? "Text will be added from the previous step."
                        : "Text will be added at runtime."}
                    </Typography>
                  </Box>
                  <InfoItem
                    header="Image"
                    inputText={
                      !isFirstStep
                        ? "Image will be added from the previous step."
                        : "Image will be added at runtime."
                    }
                  />
                </>
              )}
            </SettingItem>
            <SettingItem value={value} index={1}>
              <Box className="w-100 ">
                {/* Model */}
                <Box
                  className="conatiner-setting-item"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <label className="me-3 label-name">Model:</label>
                  <FormControl className="FormControl-appsetting" sx={{ m: 1 }}>
                    <Select
                      disabled={readOnly || videoSuiteAppSettings?.length === 1}
                      displayEmpty
                      onOpen={() => handleOpenMenu("model")}
                      onClose={() => handleCloseMenu("model")}
                      open={menuOpen.model}
                      value={
                        videoSettings?.selectedModel.name || "Select model"
                      }
                      inputProps={{ "aria-label": "Without label" }}
                      className={`app-selector-setting selected-lang-From `}
                      IconComponent={(props) => (
                        <ExpandMoreIcon
                          {...props}
                          sx={{
                            fill: "var(--Main_icons_color)",
                            opacity:
                              !readOnly && videoSuiteAppSettings?.length === 1
                                ? "0.5"
                                : "1",
                          }}
                        />
                      )}
                      sx={{
                        border: "none",
                        opacity: menuOpen.model ? "0.5" : "1",
                        color: "var(--Main_icons_color)",
                        "&.Mui-focused fieldset": {
                          border: "none",
                          outline: "0",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            minWidth: "18.7%",
                            top: "33%",
                            maxHeight: "200px",
                            backgroundColor: "var(--A_backgroundColor77)",
                            borderRadius: "8px",
                            boxShadow: "none",
                            border: "1px solid var(--A_backgroundColor80)",
                          },
                        },
                      }}
                    >
                      {videoSuiteAppSettings?.map(
                        (setting: VideoSettings, i: number) => (
                          <MenuItem
                            value={setting?.name}
                            key={i}
                            className="selected-lang"
                            sx={{
                              color: "var(--Main_icons_color)",
                              fontSize: "12px",
                              minHeight: "auto",
                              "&:hover": {
                                backgroundColor: "var(--m-background44)",
                                textDecoration: "none",
                              },
                              "&.Mui-selected": {
                                backgroundColor: "var(--M-background98)",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "var(--M-background98)",
                                textDecoration: "none",
                              },
                            }}
                            onClick={() =>
                              handleModelSettingChanges?.(
                                currentStep?.appId || "",
                                "selectedModel",
                                {
                                  name: setting.name,
                                  version: setting.version,
                                }
                              )
                            }
                          >
                            {setting.name}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Box>

                {/* Dimension */}
                <Box
                  className="conatiner-setting-item"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <label className="me-3 label-name">Dimension:</label>
                  <FormControl className="FormControl-appsetting" sx={{ m: 1 }}>
                    <Select
                      disabled={readOnly || selectedModelData?.modelDimensions.length === 0}
                      displayEmpty
                      onOpen={() => handleOpenMenu("dimension")}
                      onClose={() => handleCloseMenu("dimension")}
                      open={menuOpen.dimension}
                      value={videoSettings?.selectedSize || "Select dimension"}
                      inputProps={{ "aria-label": "Without label" }}
                      className="app-selector-setting selected-lang-From"
                      IconComponent={(props) => (
                        <ExpandMoreIcon
                          {...props}
                          sx={{ fill: "var(--Main_icons_color)" }}
                        />
                      )}
                      sx={{
                        border: "none",
                        opacity: menuOpen.dimension ? "0.5" : "1",
                        color: "var(--Main_icons_color)",
                        "&.Mui-focused fieldset": {
                          border: "none",
                          outline: "0",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            minWidth: "18.7%",
                            top: "33%",
                            maxHeight: "200px",
                            backgroundColor: "var(--A_backgroundColor77)",
                            borderRadius: "8px",
                            boxShadow: "none",
                            border: "1px solid var(--A_backgroundColor80)",
                          },
                        },
                      }}
                    >
                      {selectedModelData?.modelDimensions?.map(
                        (dim: SettingItemObjType, i: number) => (
                          <MenuItem
                            value={dim.description}
                            key={i}
                            className="selected-lang"
                            sx={{
                              color: "var(--Main_icons_color)",
                              fontSize: "12px",
                              minHeight: "auto",
                              "&:hover": {
                                backgroundColor: "var(--m-background44)",
                                textDecoration: "none",
                              },
                              "&.Mui-selected": {
                                backgroundColor: "var(--M-background98)",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "var(--M-background98)",
                                textDecoration: "none",
                              },
                            }}
                            onClick={() =>
                              handleModelSettingChanges?.(
                                currentStep?.appId || "",
                                "selectedSize",
                                dim.description
                              )
                            }
                          >
                            {dim.description}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Box>
                {/* Style */}
                {selectedModelData?.modelStyles?.length !== 1 ? (
                  <Box
                    className="conatiner-setting-item"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <label className="me-3 label-name">Style:</label>
                    <FormControl
                      className="FormControl-appsetting"
                      sx={{ m: 1 }}
                    >
                      <Select
                        disabled={readOnly || selectedModelData?.modelStyles.length === 0}
                        displayEmpty
                        onOpen={() => handleOpenMenu("style")}
                        onClose={() => handleCloseMenu("style")}
                        open={menuOpen.style}
                        value={
                          videoSettings?.selectedStyle.description ||
                          "Select style"
                        }
                        renderValue={(selected) => {
                          const selectedObj = videoSettings?.selectedStyle;
                          if (!selectedObj) return "Select style";

                          return (
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <img
                                className={`${
                                  selectedObj.description === "3D Animation" &&
                                  "ThreeD-animationImage-workflow"
                                } ${selectedObj?.description
                                  ?.toLowerCase()
                                  ?.replace(/\s+/g, "")}Image-workflow`}
                                alt={selectedObj.description}
                                width={24}
                                height={24}
                                style={{ borderRadius: "3px" }}
                              />
                              <Typography
                                sx={{
                                  color: "var(--Main_icons_color)",
                                  fontWeight: 500,
                                }}
                              >
                                {selectedObj.description}
                              </Typography>
                            </Box>
                          );
                        }}
                        inputProps={{ "aria-label": "Without label" }}
                        className="app-selector-setting selected-lang-From"
                        IconComponent={(props) => (
                          <ExpandMoreIcon
                            {...props}
                            sx={{ fill: "var(--Main_icons_color)" }}
                          />
                        )}
                        sx={{
                          border: "none",
                          opacity: menuOpen.style ? "0.5" : "1",
                          color: "var(--Main_icons_color)",
                          "&.Mui-focused fieldset": {
                            border: "none",
                            outline: "0",
                          },
                        }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              minWidth: "auto",
                              top: "33%",
                              left: "535px",
                              width: "20%",
                              backgroundColor: "var(--A_backgroundColor77)",
                              borderRadius: "8px",
                              boxShadow: "none",
                              border: "1px solid var(--A_backgroundColor80)",
                              overflow: "hidden",
                            },
                          },
                          MenuListProps: {
                            sx: {
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "nowrap",
                              overflowX: "auto",
                              overflowY: "hidden",
                              padding: 1,
                              gap: 2,
                              "&::-webkit-scrollbar": {
                                height: "6px",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                borderRadius: "4px",
                              },
                            },
                          },
                        }}
                      >
                        {selectedModelData?.modelStyles?.map(
                          (styleObj: SettingItemObjType, i: number) => {
                            const style = styleObj.description;
                            return (
                              <MenuItem
                                key={i}
                                disableGutters
                                disableRipple
                                sx={{ padding: 0, minWidth: "auto" }}
                              >
                                <Card
                                  className={`video-suite-setting-style ${
                                    style === "3D Animation" &&
                                    "ThreeD-animationImage"
                                  } ${style
                                    .toLowerCase()
                                    .replace(/\s+/g, "")}Image ${
                                    style ===
                                      videoSettings?.selectedStyle
                                        .description && "selected"
                                  }`}
                                  onClick={() =>
                                    handleModelSettingChanges?.(
                                      currentStep?.appId || "",
                                      "selectedStyle",
                                      styleObj
                                    )
                                  }
                                >
                                  <CardContent
                                    sx={{ padding: "0px", paddingTop: "88%" }}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: "Roboto",
                                        fontWeight: "400",
                                        fontSize: "14px",
                                        lineHeight: "25px",
                                        letterSpacing: "0.1px",
                                        textAlign: "center",
                                        color: "#FFFFFF",
                                      }}
                                    >
                                      {style}
                                    </Typography>
                                  </CardContent>
                                  {style ===
                                    videoSettings?.selectedStyle
                                      .description && (
                                    <Box
                                      sx={{
                                        width: "24px",
                                        height: "24px",
                                        borderRadius: "16px",
                                        padding: "5px 11px",
                                        gap: "8px",
                                        background: "#12B6EA",
                                        position: "absolute",
                                        top: "2%",
                                        right: "2%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <CheckIcon
                                        sx={{
                                          width: "18px",
                                          height: "18px",
                                          color: "white",
                                        }}
                                      />
                                    </Box>
                                  )}
                                </Card>
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Box>
                ) : null}
                {/* Quality: */}
                <Box
                  className="conatiner-setting-item"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <label className="me-3 label-name">Quality:</label>
                  <FormControl className="FormControl-appsetting" sx={{ m: 1 }}>
                     <Select
                       disabled={readOnly || selectedModelData?.modelVideoQualities?.length === 0}
                      displayEmpty
                      onOpen={() => handleOpenMenu("quality")}
                      onClose={() => handleCloseMenu("quality")}
                      open={menuOpen.quality}
                      value={videoSettings?.selectedMode || "Select quality"}
                      inputProps={{ "aria-label": "Without label" }}
                      className="app-selector-setting selected-lang-From"
                      IconComponent={(props) => (
                        <ExpandMoreIcon
                          {...props}
                          sx={{ fill: "var(--Main_icons_color)" }}
                        />
                      )}
                      sx={{
                        border: "none",
                        opacity: menuOpen.quality ? "0.5" : "1",
                        color: "var(--Main_icons_color)",
                        "&.Mui-focused fieldset": {
                          border: "none",
                          outline: "0",
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            minWidth: "18.7%",
                            top: "33%",
                            maxHeight: "200px",
                            backgroundColor: "var(--A_backgroundColor77)",
                            borderRadius: "8px",
                            boxShadow: "none",
                            border: "1px solid var(--A_backgroundColor80)",
                          },
                        },
                      }}
                    >
                      {selectedModelData?.modelVideoQualities?.map(
                        (quality: SettingItemObjType, i: number) => (
                          <MenuItem
                            value={quality.description}
                            key={i}
                            className="selected-lang"
                            sx={{
                              color: "var(--Main_icons_color)",
                              fontSize: "12px",
                              minHeight: "auto",
                              "&:hover": {
                                backgroundColor: "var(--m-background44)",
                                textDecoration: "none",
                              },
                              "&.Mui-selected": {
                                backgroundColor: "var(--M-background98)",
                              },
                              "&.Mui-selected:hover": {
                                backgroundColor: "var(--M-background98)",
                                textDecoration: "none",
                              },
                            }}
                            onClick={() =>
                              handleModelSettingChanges?.(
                                currentStep?.appId || "",
                                "selectedMode",
                                quality.description
                              )
                            }
                          >
                            {quality.description}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </Box>
                {/* Duration */}
                <Box
                  className="conatiner-setting-item"
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <label className="me-3 label-name">Duration:</label>

                  <Box
                    className="FormControl-appsetting duration-FormControl-appsettings"
                    sx={{ m: 1, ms: 0 }}
                  >
                    <>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        value={videoSettings?.selectedDuration || ""}
                        onChange={(e) =>
                          handleModelSettingChanges?.(
                            currentStep?.appId || "",
                            "selectedDuration",
                            e.target.value
                          )
                        }
                      >
                        {selectedModelData?.modelDurations?.map(
                          (durationObj: any, i: number) => {
                            return (
                              <FormControlLabel
                                key={i}
                                value={durationObj.value}
                                className="me-4 pe-3"
                                control={
                                  <Radio
                                    sx={{
                                      color: "#76CFEB33",
                                      "&.Mui-checked": {
                                        color: "#12B6EA",
                                      },
                                    }}
                                  />
                                }
                                label={`${String(durationObj.value)} s`}
                              />
                            );
                          }
                        )}
                      </RadioGroup>
                    </>
                  </Box>
                </Box>
              </Box>
            </SettingItem>
            <SettingItem value={value} index={2}>
              <OutputSettingVideo readOnly={readOnly} />
            </SettingItem>
          </Box>
        </Box>
      </Box>
    ) : (
      <Box className="w-100 d-flex flex-column justify-content-center">
        <ul className="w-100 workflow-list-readOnly">
          {/* input Type */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography>Input type:</Typography>
              {currentStep?.userInput ? (
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    margin: "4px 0px",
                    opacity: "0.7",
                    gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      gap: "8px",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "25px",
                        letterSpacing: "0.1px",
                        textDecoration: "underline",
                        color: "var(--Main_icons_color)",
                        textAlign: "left",
                      }}
                    >
                      {!isFirstStep
                        ? "Text will be added from the previous step."
                        : "Text will be added at runtime."}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      minHeight: "55px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: " 8px",
                      position: "relative",
                      backgroundColor: " var(--A_backgroundColor97)",
                      border: "1px solid var(--A_backgroundColor98)",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <img
                        src={
                          typeof currentStep?.userInput === "string"
                            ? currentStep?.userInput
                            : currentStep?.userInput
                            ? URL.createObjectURL(currentStep?.userInput)
                            : undefined
                        }
                        className="image-to-video-setting-readOnly"
                        alt="Uploaded preview"
                      />
                      <Typography
                        sx={{
                          fontFamily: "Roboto",
                          fontWeight: "500",
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0.5px",
                          color: "var(--Main_icons_color)",
                        }}
                      >
                        {typeof currentStep?.userInput === "string"
                          ? "Image.png"
                          : currentStep?.userInput instanceof File
                          ? getTruncatedFilename(currentStep?.userInput)
                          : ""}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Roboto",
                          fontWeight: "500",
                          fontSize: "12px",
                          lineHeight: "16px",
                          letterSpacing: "0.5px",
                          color: "var(--Main_icons_color)",
                          opacity: "0.5",
                        }}
                      >
                        {currentStep?.userInput instanceof File
                          ? (
                              currentStep?.userInput?.size /
                              (1024 * 1024)
                            ).toFixed(2) + " MB"
                          : ""}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : currentStep?.userInputText ? (
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    margin: "4px 0px",
                    opacity: "0.7",
                    gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "25px",
                        letterSpacing: "0.1px",
                        textDecoration: "underline",
                        color: "var(--Main_icons_color)",
                        textAlign: "left",
                      }}
                    >
                      {!isFirstStep
                        ? "Image will be added from the previous step."
                        : "Image will be added at runtime."}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: "400",
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.4px",
                        color: "var(--Main_icons_color)",
                      }}
                    >
                      Prompt
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        border: "1px solid var(--A-background55)",
                        borderRadius: "12px",
                        mt: "8px",
                        padding: "8px",
                      }}
                    >
                      <div className="input-suite-container">
                        <textarea
                          readOnly={readOnly}
                          value={currentStep?.userInputText}
                          placeholder="Describe the video content you want to generate..."
                          className="custom-textarea-suite"
                          rows={3}
                        />
                      </div>
                    </Box>
                  </Box>
                </Box>
              ) : !currentStep?.userInputText && !currentStep?.userInput ? (
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    flexDirection: "column",
                    margin: "4px 0px",
                    opacity: "0.7",
                    gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      gap: "8px",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "25px",
                        letterSpacing: "0.1px",
                        textDecoration: "underline",
                        color: "var(--Main_icons_color)",
                        textAlign: "left",
                      }}
                    >
                      {!isFirstStep
                        ? "Text will be added from the previous step."
                        : "Text will be added at runtime."}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "16px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Roboto",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "25px",
                        letterSpacing: "0.1px",
                        textDecoration: "underline",
                        color: "var(--Main_icons_color)",
                        textAlign: "left",
                      }}
                    >
                      {!isFirstStep
                        ? "Image will be added from the previous step."
                        : "Image will be added at runtime."}
                    </Typography>
                  </Box>
                </Box>
              ) : null}
            </Box>
          </li>
          {/* settings */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Typography>Settings:</Typography>
              <Box className="container-workflow-setting-redaOnly">
                <Box
                  className="workflow-parameter-item-readOnly"
                  sx={{
                    paddingBottom: "16px",
                    borderBottom: "1px solid var(--A_backgroundColor102)",
                  }}
                >
                  <Typography className="paramter-value-setting">
                    Select model:
                  </Typography>
                  <Typography className="paramter-value-setting">
                    {videoSettings?.selectedModel.name}
                  </Typography>
                </Box>

                <Box
                  className="workflow-parameter-item-readOnly"
                  sx={{
                    padding: "16px 0px",
                    borderBottom: "1px solid var(--A_backgroundColor102)",
                  }}
                >
                  <Typography className="paramter-value-setting">
                    Select dimension:
                  </Typography>
                  <Typography className="paramter-value-setting">
                    {videoSettings?.selectedSize}
                  </Typography>
                </Box>
                {selectedModelData?.modelStyles?.length !== 1 ? (
                  <Box
                    className="workflow-parameter-item-readOnly"
                    sx={{
                      padding: "16px 0px",
                      borderBottom: "1px solid var(--A_backgroundColor102)",
                    }}
                  >
                    <Typography className="paramter-value-setting">
                      Select style:
                    </Typography>
                    <Typography className="paramter-value-setting">
                      {videoSettings?.selectedStyle.description}
                    </Typography>
                  </Box>
                ) : null}

                <Box
                  className="workflow-parameter-item-readOnly"
                  sx={{
                    padding: "16px 0px",
                    borderBottom: "1px solid var(--A_backgroundColor102)",
                  }}
                >
                  <Typography className="paramter-value-setting">
                    Select quality:
                  </Typography>
                  <Typography className="paramter-value-setting">
                    {videoSettings?.selectedMode}
                  </Typography>
                </Box>
                <Box
                  className="workflow-parameter-item-readOnly"
                  sx={{
                    paddingTop: "16px",
                  }}
                >
                  <Typography className="paramter-value-setting">
                    Selected duration:
                  </Typography>
                  <Typography className="paramter-value-setting">
                    {videoSettings?.selectedDuration}s
                  </Typography>
                </Box>
              </Box>
            </Box>
          </li>
          {/* output Type */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography>Output type:</Typography>
              <OutputSettingVideo readOnly={readOnly} />
            </Box>
          </li>
        </ul>
      </Box>
    )
  ) : null;
};

export default ImageToVideoSetting;
